import _ from 'lodash';

import APIClient from '../lib/APIClient';
import { resolveAll } from '../helpers/LinkMapper';

import Fare from '../records/Fare';

const OpenGolfService = {
    async getTickets(search) {
        let response;
        let railcards = search.railcards.toJS().flatMap(railcard => _.times(railcard.quantity ? railcard.quantity : 1, () => String(railcard.code)));

        const request = {
            "origin": search.getIn(['origin', 'nlc'], ''),
            "destination": "5026",
            "adults": search.adults,
            "children": search.children,
            railcards
        };

        try {
            response = await APIClient.post(
                '/jp/open-golf-tickets',
                request
            );

            return resolveAll(response.result).as(Fare);
        } catch (error) {
            throw new Error(error);
        }
    },
};

export default OpenGolfService;



// WEBPACK FOOTER //
// ./src/services/OpenGolfService.js